import React from "react";

const NoResults = () => {
  return (
    <div className="products">
      <div className="no-results">

        <div className="no-results__scene">
          <div className="no-results__orb no-results__orb--1" />
          <div className="no-results__orb no-results__orb--2" />
          <div className="no-results__tree-wrap">
            <div className="no-results__leaves">
              <span /><span /><span /><span /><span />
            </div>
            <svg
              className="no-results__img"
              viewBox="0 0 120 160"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              width="120"
              height="160"
            >
              {/* Trunk */}
              <rect x="52" y="100" width="16" height="50" rx="6" fill="#b5845a" opacity="0.7"/>
              {/* Main branches */}
              <line x1="60" y1="110" x2="25" y2="75" stroke="#b5845a" strokeWidth="5" strokeLinecap="round" opacity="0.65"/>
              <line x1="60" y1="100" x2="90" y2="65" stroke="#b5845a" strokeWidth="4.5" strokeLinecap="round" opacity="0.65"/>
              <line x1="60" y1="115" x2="30" y2="95" stroke="#b5845a" strokeWidth="3.5" strokeLinecap="round" opacity="0.55"/>
              <line x1="60" y1="108" x2="95" y2="90" stroke="#b5845a" strokeWidth="3" strokeLinecap="round" opacity="0.55"/>
              {/* Sub-branches */}
              <line x1="25" y1="75" x2="10" y2="55" stroke="#b5845a" strokeWidth="3" strokeLinecap="round" opacity="0.5"/>
              <line x1="25" y1="75" x2="38" y2="52" stroke="#b5845a" strokeWidth="2.5" strokeLinecap="round" opacity="0.5"/>
              <line x1="90" y1="65" x2="105" y2="45" stroke="#b5845a" strokeWidth="3" strokeLinecap="round" opacity="0.5"/>
              <line x1="90" y1="65" x2="78" y2="44" stroke="#b5845a" strokeWidth="2.5" strokeLinecap="round" opacity="0.5"/>
              <line x1="10" y1="55" x2="5"  y2="38"  stroke="#b5845a" strokeWidth="2" strokeLinecap="round" opacity="0.4"/>
              <line x1="38" y1="52" x2="45" y2="35"  stroke="#b5845a" strokeWidth="2" strokeLinecap="round" opacity="0.4"/>
              <line x1="78" y1="44" x2="70" y2="28"  stroke="#b5845a" strokeWidth="2" strokeLinecap="round" opacity="0.4"/>
              <line x1="105" y1="45" x2="112" y2="30" stroke="#b5845a" strokeWidth="2" strokeLinecap="round" opacity="0.4"/>
            </svg>
            <div className="no-results__shadow" />
          </div>
        </div>

        <h2 className="no-results__title">No products found</h2>
        <p className="no-results__sub">Try a different keyword or browse all categories</p>

        <div className="no-results__dots">
          <span /><span /><span />
        </div>

      </div>
    </div>
  );
};

export default NoResults;
